var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_854_13724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.4848 69.2254C72.4903 69.2254 74.1161 67.5997 74.1161 65.5942C74.1161 63.5887 72.4903 61.9629 70.4848 61.9629C68.4793 61.9629 66.8535 63.5887 66.8535 65.5942C66.8535 67.5997 68.4793 69.2254 70.4848 69.2254Z",
    fill: "#61DAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4849 73.0339C81.2461 73.0339 89.9697 69.703 89.9697 65.5942C89.9697 61.4854 81.2461 58.1545 70.4849 58.1545C59.7237 58.1545 51 61.4854 51 65.5942C51 69.703 59.7237 73.0339 70.4849 73.0339Z",
    stroke: "#61DAFB",
    strokeWidth: 2.05942
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0421 69.3141C69.4227 78.6335 76.6691 84.523 80.2275 82.4686C83.7858 80.4142 82.3086 71.1939 76.928 61.8744C71.5474 52.5549 64.3009 46.6654 60.7426 48.7198C57.1843 50.7743 58.6615 59.9946 64.0421 69.3141Z",
    stroke: "#61DAFB",
    strokeWidth: 2.05942
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0416 61.8744C58.661 71.1939 57.1838 80.4142 60.7421 82.4686C64.3004 84.5231 71.5469 78.6336 76.9275 69.3141C82.3081 59.9946 83.7853 50.7743 80.227 48.7199C76.6686 46.6654 69.4222 52.5549 64.0416 61.8744Z",
    stroke: "#61DAFB",
    strokeWidth: 2.05942
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 36.5,
    width: 59,
    height: 59,
    rx: 5.5,
    stroke: "#04B2AE",
    strokeOpacity: 0.965
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_854_13724",
    x: 0,
    y: 0,
    width: 140,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_854_13724"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_854_13724",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.dd924229660f1f706ecf9060fd097aef.svg";
export { ForwardRef as ReactComponent };